import { BasePageComponent } from './base-page.component';
import { ModalComponent } from './modal/modal.component';
import { SelectorComponent, MultipleSelectorComponent } from './utils/index';
import { PeopleService } from './shared/services/people.service';
import { Component } from '@angular/core';

@Component({
    providers: [PeopleService],
    template: '',
    standalone: false
})
export class BaseModalPageComponent extends BasePageComponent {
  openSelector(
    modal: ModalComponent,
    selectorValues: any,
    selectedIndex: any,
    {
      search = false,
      searchFromStart = false,
      none = false,
      showAsIcons = false
    }: {
      search?: boolean;
      searchFromStart?: boolean;
      none?: boolean;
      showAsIcons?: boolean;
    } = {}
  ) {
    modal.modalFooter = false;
    modal.modalHeader = false;
    modal.modalMessage = false;
    modal.open(SelectorComponent, {
      values: selectorValues,
      selectedIndex,
      search,
      searchFromStart,
      none,
      showAsIcons
    });
  }

  openMultipleSelector(modal: ModalComponent, selectorValues: any, search: boolean = false) {
    modal.modalFooter = false;
    modal.modalHeader = false;
    modal.modalMessage = false;

    modal.open(MultipleSelectorComponent, {
      values: selectorValues,
      search: search
    });
  }
}
